import React, {FunctionComponent} from "react";
import makeStyles from '@mui/styles/makeStyles';
import Carousel from 'react-material-ui-carousel';
import {useTranslation} from "react-i18next";


interface RatingPartnersData {
    partners: string[]
}

const RatingPartners: FunctionComponent<RatingPartnersData> = ({partners}) => {
    const {t} = useTranslation()
    const classes = useStyles();

    if (!partners.length) return null;

    return (
        <>
            <h3 className={classes.header}>{t('ratingPartners')}</h3>
            <Carousel className={classes.carousel}
                      animation="slide"
                      autoPlay={true}
                      timeout={500}
                      interval={5000}
                      indicators={false}
            >
                {
                    partners.map(partner => (
                        <img src={partner} key={partner} className={classes.logo} alt="partner logo"/>
                    ))
                }
            </Carousel>

        </>
    )
}

const useStyles = makeStyles(muiTheme => ({
    header: {
        color: muiTheme.palette.primary.contrastText,
        padding: '1rem 5rem 1rem 1.5rem',
        fontSize: '1.15rem',
        fontWeight: 500,
        background: `url(${require('../../assets/icons/primary_rect.svg')})`,
        backgroundRepeat: 'no-repeat',
        display: 'inline-block',
        backgroundPositionX: 'right',
        backgroundSize: 'cover'
    },
    logo: {
        height: '7rem',
    },
    carousel: {
        margin: '1.5rem 0 1rem',
        minWidth: '3rem',
        height: '7rem',
        textAlign: 'center'
    }
}))

export default RatingPartners